import React, { useEffect, useRef, useState } from "react";
import { useSEO } from "../../context/SEOContext";
import "./Home.css";
import Slider from "../../components/Slider/Slider";
//import HomeBanner from "./../../assets/homepagebannernew2.webp";
//import HomeBannerMobil from "./../../assets/homepagebannermobile.webp";
import HomeBannerMen from "./../../assets/home1.webp";
import VideoSrc from "./../../assets/homebannerM4.mp4";
import VideoSrcMobile from "./../../assets/homebannerM4mobile.mp4";
import HomeBannerMobil from "./../../assets/home1mobile.webp";
// import Logo1 from "./../../assets/home/test1.png";
// import Logo2 from "./../../assets/home/test2.png";
// import Finalist1 from "./../../assets/home/finalist1.png";
// import Finalist2 from "./../../assets/home/finalist2.png";
// import Finalist3 from "./../../assets/home/finalist3.png";
import Application from "../../components/Application/Application";
import categoryData from "../../api/categories";
import { formatPage } from "../../utils/formatPage";
import { useTranslation } from "react-i18next";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Pagination, Navigation } from "swiper/modules";
import CustomerReviews from "../../components/CustomerReviews/CustomerReviews";
import CatalogSection from "../../components/CatalogSection/CatalogSection";
import NotesSection from "../../components/NotesSection/NotesSection";

import MenFoto from "./../../assets/perfume/parfumepagemen.webp";
import BannerMenBottom from "./../../assets/perfume/bannerbttom.webp";
import WomenFoto from "./../../assets/perfume/parfumpagewomen.webp";
import MainCharactersBannerWomen from "../../assets/mcwomen.webp";
import MainCharactersBannerMen from "./../../assets/mcmen.webp";
import BannerWomanBottom from "./../../assets/perfume/bannerbottomfemale.webp";
import Artboard1 from "./../../assets/perfume/artboard1.webp";
import Artboard2 from "./../../assets/perfume/artboard2.webp";
import Artboard3 from "./../../assets/perfume/artboard3.webp";
import { useLocation } from "react-router-dom";
import FairsData from "../../api/FairsData";
const WelcomeOverlay = React.lazy(
  () => import("../../views/WelcomeModal/WelcomeModal"),
);
const NoteBlock = ({ image, title, notes }) => (
  <div className="d-flex align-items-center mt-4">
    <img src={image} alt={title} className="me-3 artbmoardsize" />
    <div>
      <p className="mb-1 fw-semibold">{title}</p>
      <p className="mb-0 text-muted">{notes}</p>
    </div>
  </div>
);

const BannerOverlay = ({ img, text }) => (
  <div className="row mt-5 d-none d-sm-block">
    <div
      className="col-lg-12 px-0 position-relative"
      style={{ height: "440px" }}
    >
      <img
        src={img}
        alt="Mukemel Perfume for Men & Women"
        className="w-100 h-100"
      />
      {/* <div className="position-absolute top-50 start-50 translate-middle text-center text-white perfumebannertext">
        <div className="bgbannercolor p-4">
          <p>{text}</p>
        </div>
      </div> */}
    </div>
  </div>
);

const AccordionSection = ({ gender, inspiration, id }) => {
  const { t } = useTranslation();
  return (
    <div className="mt-5">
      <div className="accordion" id={`accordion${id}`}>
        <div className="accordion-item">
          <h2 className="accordion-header" id={`headingGender${id}`}>
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target={`#collapseGender${id}`}
              aria-expanded="false"
              aria-controls={`collapseGender${id}`}
            >
              {t("Gender")}
            </button>
          </h2>
          <div
            id={`collapseGender${id}`}
            className="accordion-collapse collapse"
            aria-labelledby={`headingGender${id}`}
            data-bs-parent={`#accordion${id}`}
          >
            <div className="accordion-body">{gender}</div>
          </div>
        </div>
        <div className="accordion-item">
          <h2 className="accordion-header" id={`headingInspiration${id}`}>
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target={`#collapseInspiration${id}`}
              aria-expanded="false"
              aria-controls={`collapseInspiration${id}`}
            >
              {t("Inspiration")}
            </button>
          </h2>
          <div
            id={`collapseInspiration${id}`}
            className="accordion-collapse collapse"
            aria-labelledby={`headingInspiration${id}`}
            data-bs-parent={`#accordion${id}`}
          >
            <div className="accordion-body">{inspiration}</div>
          </div>
        </div>
      </div>
    </div>
  );
};
const Home = () => {
  const { t } = useTranslation();

  const location = useLocation();
  const homeNewsItems = FairsData.upcoming;

  const [open, setOpen] = useState(false);
  const [isMuted, setIsMuted] = useState(true);
  const desktopVideoRef = useRef(null);
  const [isMobileMuted, setIsMobileMuted] = useState(true);
  const mobileVideoRef = useRef(null);

  const toggleMute = () => {
    if (desktopVideoRef.current) {
      desktopVideoRef.current.muted = !desktopVideoRef.current.muted;
      setIsMuted(desktopVideoRef.current.muted);
    }
  };

  const toggleMobileMute = () => {
    if (mobileVideoRef.current) {
      mobileVideoRef.current.muted = !mobileVideoRef.current.muted;
      setIsMobileMuted(mobileVideoRef.current.muted);
    }
  };

  const handleClose = () => {
    localStorage.setItem("welcome_modal_dismissed", "1");
    setOpen(false);
  };

  const setSeo = useSEO();
  useEffect(() => {
    setSeo({
      title: t("home.meta.title"),
      description: t("home.meta.description"),
      keywords: t("home.meta.keywords"),
      siteName: "Touch Of Soul",
      favicon: "/faviconnew.png",
      ogImage:
        "https://mukemel.com/static/media/brothers.c791973cd1c46d462816.webp",
      ogUrl: "https://mukemel.com",
      ogType: "website", // ya da 'website'
    });
  }, [setSeo, t]);

  return (
    <>
      <Slider />

      <div className="container-fluid p-lg-5" style={{ marginTop: "30px" }}>
        <div className="row text-center">
          {/* DESKTOP */}
          <div className="col-12 px-0 d-none d-sm-block">
            <Swiper
              pagination={{ clickable: true }}
              modules={[Pagination]}
              className="mySwiper homeSwiper"
            >
              <SwiperSlide>
                <div
                  className="videoSlide position-relative overflow-hidden"
                  style={{ height: "900px" }}
                >
                  <video
                    ref={desktopVideoRef}
                    src={VideoSrc}
                    autoPlay
                    muted
                    loop
                    playsInline
                    preload="auto"
                    className="d-block"
                  />
                  <button
                    className="video-mute-btn position-absolute"
                    onClick={toggleMute}
                    aria-label={isMuted ? "Sesi aç" : "Sesi kapat"}
                  >
                    {isMuted ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="22"
                        height="22"
                        fill="white"
                        viewBox="0 0 24 24"
                      >
                        <path d="M16.5 12A4.5 4.5 0 0 0 14 7.97V10.18l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51A8.796 8.796 0 0 0 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3 3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06A8.99 8.99 0 0 0 17.73 19 11.3 11.3 0 0 0 19.73 17l1 1L22 16.73l-9-9L4.27 3zM12 4 9.91 6.09 12 8.18V4z" />
                      </svg>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="22"
                        height="22"
                        fill="white"
                        viewBox="0 0 24 24"
                      >
                        <path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3A4.5 4.5 0 0 0 14 7.97v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z" />
                      </svg>
                    )}
                  </button>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div
                  className="position-relative overflow-hidden"
                  style={{ height: "900px" }}
                >
                  <a href="/category/perfume">
                    <img
                      src={HomeBannerMen}
                      className="w-100"
                      alt={t("PerfumeImageAlt")}
                      loading="lazy"
                      decoding="async"
                      width={450}
                      style={{
                        height: "100%",
                        display: "block",
                        objectFit: "",
                      }}
                    />
                    {/* <div className="position-absolute top-50 start-50 translate-middle">
                      <h1 className="text-dark fw-bold m-0 p-2 opacity-75 rounded bannertextsize1">
                        {t("Niche")}
                        <br />
                        {t("Handmade Perfume")}
                      </h1>
                    </div>
                    <div className="bannerLogoContent position-absolute bottom-0 start-50 translate-middle-x w-100 mb-5">
                      <div className="container">
                        <div className="row justify-content-between align-items-center">
                          <div className="col-lg-4 col-md-5 col-12 text-center mb-5">
                            <p className="text-white fw-light mb-3 bannerLogoText">
                              {t("Finalist")}
                            </p>

                            <div className="d-flex align-items-center justify-content-center gap-3">
                              <img
                                src={Finalist1}
                                alt="Logo 1"
                                className="bannerLogo"
                              />
                              <img
                                src={Finalist2}
                                alt="Logo 2"
                                className="bannerLogo"
                              />
                            </div>
                          </div>
                          <div className="col-lg-4 col-md-5 col-12 d-flex flex-column align-items-center text-center mb-5">
                            <p className="text-white fw-light mb-3 bannerLogoText">
                              {t("OfficialRecognition")}
                            </p>
                            <img
                              src={Finalist3}
                              alt="Logo 3"
                              className="bannerLogo"
                            />
                          </div>

                          <div className="col-lg-4 col-md-5 col-12 text-center mb-5">
                            <p className="text-white fw-light mb-3 bannerLogoText">
                              {t("Memberof")}
                            </p>

                            <div className="d-flex align-items-center justify-content-center gap-3">
                              <img
                                src={Logo1}
                                alt="Logo 1"
                                className="bannerLogo"
                              />
                              <img
                                src={Logo2}
                                alt="Logo 2"
                                className="bannerLogo"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div> */}
                  </a>
                </div>
              </SwiperSlide>
            </Swiper>
          </div>

          {/* MOBILE */}
          <div className="col-12 px-0 d-block d-sm-none">
            <Swiper
              pagination={{ clickable: true }}
              navigation={true}
              modules={[Pagination, Navigation]}
              className="mySwiper mobile-home-swiper"
            >
              <SwiperSlide>
                <div className="videoSlide position-relative overflow-hidden">
                  <video
                    ref={mobileVideoRef}
                    src={VideoSrcMobile}
                    autoPlay
                    muted
                    loop
                    playsInline
                    preload="auto"
                    className="d-block"
                  />
                  <button
                    className="video-mute-btn position-absolute"
                    onClick={toggleMobileMute}
                    aria-label={isMobileMuted ? "Sesi aç" : "Sesi kapat"}
                  >
                    {isMobileMuted ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="22"
                        height="22"
                        fill="white"
                        viewBox="0 0 24 24"
                      >
                        <path d="M16.5 12A4.5 4.5 0 0 0 14 7.97V10.18l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51A8.796 8.796 0 0 0 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3 3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06A8.99 8.99 0 0 0 17.73 19 11.3 11.3 0 0 0 19.73 17l1 1L22 16.73l-9-9L4.27 3zM12 4 9.91 6.09 12 8.18V4z" />
                      </svg>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="22"
                        height="22"
                        fill="white"
                        viewBox="0 0 24 24"
                      >
                        <path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3A4.5 4.5 0 0 0 14 7.97v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z" />
                      </svg>
                    )}
                  </button>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="bannerSlide position-relative overflow-hidden d-block d-sm-none">
                  <a href="/category/perfume" className="text-decoration-none">
                    {/* Arka plan görsel */}
                    <img
                      src={HomeBannerMobil}
                      className="w-100 img-fluid d-block"
                      alt={t("PerfumeImageAlt")}
                      loading="lazy"
                      decoding="async"
                      width={450}
                    />
                  </a>
                </div>
              </SwiperSlide>
            </Swiper>
          </div>
        </div>
      </div>

      {/* <div className="container">
        <div className="row">
          <p className="text-uppercase text-center fs-11 pt-5 mb-0 fw-lighter">
            MÜKEMEL
          </p>
          <h3 className="text-center pt-0 pb-4 fw-light">
            {t("Visit our Store")}
          </h3>
          <HomeProduct />
        </div>
      </div> */}

      <div className="container my-5">
        {/* Women Section */}
        <div className="row pb-5 mt-5">
          <div className="col-lg-6 text-center px-0">
            <div className="position-relative d-block">
              <a href="/product/218">
                <img
                  src={WomenFoto}
                  className="w-100 mb-4"
                  alt="Perfume for Women perfume with raspberry, orange and amber notes"
                  title="Perfume for Women"
                />
                <p className="text-decoration-underline text-white mb-5 position-absolute bottom-0 start-50 translate-middle-x border border-light p-2 pe-4 px-4 rounded-2 fw-bold">
                  {t("View More")}
                </p>
              </a>
            </div>
          </div>
          <div className="col-lg-6 px-4">
            <h2 className="fs-5 mt-4">{t("Perfume for Women")}</h2>
            <NotesSection
              variant="women"
              Artboard1={Artboard1}
              Artboard2={Artboard2}
              Artboard3={Artboard3}
              NoteBlock={NoteBlock}
            />
            <AccordionSection
              id="Women"
              gender={t("Women")}
              inspiration={t("WomenDesc")}
            />
          </div>
        </div>
        {/* Women Pyramid Section */}
        <div className="d-none d-sm-block">
          <div className="row">
            <img
              src={MainCharactersBannerWomen}
              className="w-100 pe-0 px-0 pt-4"
              alt="Mukemel Perfume for"
            />
          </div>
        </div>
        {/* <div className="d-none d-sm-block" style={{ minHeight: "447px" }}>
          <div className="row p-5 align-items-center mt-5  bgcolor2">
            <div className="col-lg-6 order-2 order-lg-1 d-flex flex-column align-items-center justify-content-center text-center ">
              <div className="row justify-content-center">
                <div className="col-lg-8">
                  <p className="mb-0 fs-5 fw-normal textcolorred">
                    {t("MenCharactersDesc")}
                    <p className="fs-3"> {t("Worththewait")}</p>
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-6 order-1 order-lg-2">
              <div className="text-center mb-3">
                <h2 className="fs-5 mb-1">{t("MÜKEMEL Perfume by I&F")}</h2>
                <h3 className="fs-6 fw-light mb-0">{t("Main characters")}</h3>
              </div>
              <PyramidSection
                image1={WomenImage1}
                image2={WomenImage2}
                image3={WomenImage3}
              />
            </div>
          </div>
        </div> */}

        <BannerOverlay img={BannerWomanBottom} text={t("WomenDesc")} />
        {/* Men Section */}
        <div className="row mt-5 ">
          <div className="col-lg-6 text-center px-0">
            <div className="position-relative d-block">
              <a href="/product/219">
                <img
                  src={MenFoto}
                  className="w-100 mb-4"
                  alt="Perfume for Men perfume with grapefruit, vanilla and amber notes"
                  title="Perfume for Men"
                />
                <p className="text-decoration-underline text-white mb-5 position-absolute bottom-0 start-50 translate-middle-x border border-light p-2 pe-4 px-4 rounded-2 fw-bold">
                  {t("View More")}
                </p>
              </a>
            </div>
          </div>
          <div className="col-lg-6 px-4">
            <h2 className="fs-5 mt-4">{t("Perfume for Men")}</h2>
            <NotesSection
              variant="men"
              Artboard1={Artboard1}
              Artboard2={Artboard2}
              Artboard3={Artboard3}
              NoteBlock={NoteBlock}
            />
            <AccordionSection
              id="Men"
              gender={t("Men")}
              inspiration={t("MenDesc")}
            />
          </div>
        </div>
        {/* Men Pyramid Section */}

        <div className="d-none d-sm-block">
          <div className="row">
            <img
              src={MainCharactersBannerMen}
              className="w-100 pe-0 px-0 pt-4"
              alt="Mukemel Perfume for"
            />
          </div>
        </div>

        {/* <div className="d-none d-sm-block" style={{ minHeight: "447px" }}>
          <div className="row p-5 align-items-center mt-5  bgcolor2">
            <div className="col-lg-6 order-2 order-lg-1 d-flex flex-column align-items-center justify-content-center text-center">
              <div className="row justify-content-center">
                <div className="col-lg-8">
                  <p className="mb-0 fs-5 fw-normal textcolorred">
                    {t("MenCharactersDesc")}
                    <p className="fs-3"> {t("Worththewait")}</p>
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-6 order-1 order-lg-2">
              <div className="text-center mb-3">
                <h2 className="fs-5 mb-1">{t("MÜKEMEL Perfume by I&F")}</h2>
                <h3 className="fs-6 fw-light mb-0">{t("Main characters")}</h3>
              </div>

              <PyramidSection
                image1={MenImage1}
                image2={MenImage2}
                image3={MenImage3}
              />
            </div>
          </div>
        </div> */}
        <BannerOverlay img={BannerMenBottom} text={t("MenDesc")} />
      </div>

      {/* YouTube Section */}
      <div className="container mb-5 pe-0 px-0 video-section-swiper">
        <Swiper
          spaceBetween={30}
          pagination={{ clickable: true, el: ".video-swiper-pagination" }}
          navigation={true}
          modules={[Pagination, Navigation]}
          className="mySwiper"
          breakpoints={{
            0: { slidesPerView: 1 },
            640: { slidesPerView: 1 }, // istersen 2 yap
            1024: { slidesPerView: 2 }, // desktop'ta yan yana 2 video
          }}
        >
          <SwiperSlide>
            <div className="text-center mt-3">
              <h2 className="fs-5 mb-3">{t("Fragrance for men")}</h2>
              <div className="ratio ratio-16x9">
                <iframe
                  src="https://www.youtube.com/embed/zQQFBriEXEg"
                  title={t("Mukemel Fragrance Ad for Men")}
                  allowFullScreen
                />
              </div>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="text-center mt-3">
              <h2 className="fs-5 mb-3">{t("Fragrance for women")}</h2>
              <div className="ratio ratio-16x9">
                <iframe
                  src="https://www.youtube.com/embed/3vBHdvg7z4k"
                  title={t("Mukemel Fragrance for Women")}
                  allowFullScreen
                />
              </div>
            </div>
          </SwiperSlide>
        </Swiper>
        <div className="video-swiper-pagination mb-5 text-center" />
      </div>

      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <h3 className="text-center fw-normal py-5 pb-3">
              {t("Shop by Category")}
            </h3>
          </div>
        </div>
        <div className="row">
          <Swiper
            slidesPerView={3}
            spaceBetween={30}
            pagination={{
              clickable: true,
            }}
            modules={[Pagination]}
            className="mySwiper"
            breakpoints={{
              // Mobil (0 - 639px)
              0: {
                slidesPerView: 1,
              },
              // Tablet (640px - 1023px)
              640: {
                slidesPerView: 2,
              },
              // Masaüstü (1024px ve üstü)
              1024: {
                slidesPerView: 3,
              },
              1440: {
                slidesPerView: 4,
              },
            }}
          >
            {categoryData.category.map((category) => (
              <SwiperSlide key={category.id}>
                <a
                  href={`/category/${formatPage(category.categoryname)}`}
                  className="text-decoration-none"
                >
                  <img
                    className="w-100 d-block"
                    loading="lazy"
                    decoding="async"
                    alt={t(`${category.categoryname}`)}
                    src={category.categoryimage}
                    width={300}
                    height={375}
                    style={{ height: "auto" }}
                  />

                  <p className="text-center fw-light mt-3 mb-5 text-dark fs-6 text-uppercase">
                    {t(category.translationKey) || category.categoryname}
                  </p>
                </a>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>

      <div className="container">
        <div className="row justify-content-center">
          <p className="text-uppercase text-center fs-11 pt-5 mb-0 fw-lighter">
            MÜKEMEL
          </p>

          <h3 className="text-center fw-light mb-5">
            {" "}
            <a href="/news" className="text-decoration-none text-dark">
              {t("News")}{" "}
            </a>
          </h3>

          <div className="col-lg-12 pe-0 px-0 news-reviews-swiper">
            {homeNewsItems.length > 0 && (
              <>
                <Swiper
                  pagination={{ clickable: true }}
                  navigation={true}
                  modules={[Pagination, Navigation]}
                  className="mySwiper d-none d-sm-block"
                >
                  {homeNewsItems.map((item) => (
                    <SwiperSlide key={item.id}>
                      <div className="bannerSlide position-relative">
                        <a
                          href={item.link || "/news"}
                          className="text-decoration-none"
                        >
                          <img
                            src={item.image || item.mobileImage}
                            className="w-100"
                            alt={item.title || t("PerfumeImageAlt")}
                            loading="lazy"
                            decoding="async"
                            width={1920}
                            style={{ height: "350px", display: "block" }}
                          />
                        </a>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
                {/*MOBİL */}
                <Swiper
                  pagination={{ clickable: true }}
                  navigation={true}
                  modules={[Pagination, Navigation]}
                  className="mySwiper d-block d-sm-none"
                >
                  {homeNewsItems.map((item) => (
                    <SwiperSlide key={`${item.id}-mobile`}>
                      <div className="bannerSlide position-relative">
                        <a
                          href={item.link || "/news"}
                          className="text-decoration-none"
                        >
                          <img
                            src={item.mobileImage || item.image}
                            className="w-100"
                            alt={item.title || t("PerfumeImageAlt")}
                            loading="lazy"
                            decoding="async"
                            width={1920}
                            style={{ height: "auto", display: "block" }}
                          />
                        </a>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </>
            )}
          </div>
        </div>
      </div>

      <div className="container pb-5">
        <div className="row justify-content-center">
          <p className="text-uppercase text-center fs-11 pt-5 mb-0 fw-lighter">
            MÜKEMEL
          </p>
          <h3 className="text-center pt-0 pb-4 fw-light">
            {t("CustomerReviews")}
          </h3>
          <div className="col-lg-8">
            <CustomerReviews />
          </div>
        </div>
      </div>
      <CatalogSection />
      <Application />
      <div className="container"></div>
      {location.pathname === "/" && open && (
        <React.Suspense fallback={null}>
          <WelcomeOverlay open={open} onClose={handleClose} />
        </React.Suspense>
      )}
    </>
  );
};
export default Home;
